import parse from 'html-react-parser';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import useLocalization from '../../../hooks/use-localization';
import '../../../resources/css/post.css';
import DateLabel from './parts/DateLabel';
import Image from './parts/Image';
import ManagePostLink from './parts/ManagePostLink';
import Meta from './parts/Meta';

export default function Post({ data }) {

    const localization = useLocalization();
    const { token } = useSelector((state) => state.environment);
    const navigate = useNavigate();

    useEffect(() => {
        if (!data.categories) {
            navigate("/news");
        }
    }, [data.categories, navigate]);

    const contentHtml = parse(data.content);

    return (
        <div className="post-root">
            {data.categories &&
                <div className="post-container">
                    <div className="post-primary">
                        <div className="post">
                            <div className="post-header">

                                <DateLabel value={data.creationDate}></DateLabel>

                                <Image src={data.topImage} alt={data.title} />

                                <Meta author={data.author} categories={data.categories}></Meta>

                                {token && <ManagePostLink id={data.id}>{localization.editPost}</ManagePostLink>}

                            </div>
                            <div className="post-content">
                                {contentHtml}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}